import React, { Component } from 'react';
import Five from './8900_Bedroom2.jpg';
import TiArrowRight from 'react-icons/lib/ti/arrow-right';
import TiWeatherSnow from 'react-icons/lib/ti/weather-snow';
import FaBed from 'react-icons/lib/fa/bed';
import MdLocalLaundryService from 'react-icons/lib/md/local-laundry-service';
import MdAllInclusive from 'react-icons/lib/md/all-inclusive';
import MdLocalParking from 'react-icons/lib/md/local-parking';
import FaTelevision from 'react-icons/lib/fa/television';
import TiBell from 'react-icons/lib/ti/bell';
import MdWifi from 'react-icons/lib/md/wifi';
import MdKitchen from 'react-icons/lib/md/kitchen';
import Fade from 'react-reveal/Fade';
import rightarrow from './rightarrow.png';
import Center from './Center';
import { Parallax, ParallaxProvider, ParallaxBanner } from 'react-scroll-parallax';
import FurnishedLiving from './FurnishedLiving';

import { Link } from 'react-router-dom';

class Amenities extends Component {
  render(){
    var p = this.props;
    return (
      <div className="amenities-container" id={p.name} style={{position: 'relative', ...style.frame}}>
          <div className="col-lg-1 hidden-md hidden-sm hidden-xs"></div>
          <Fade>
            <div className="parallax-amenities-image-container col-lg-5 col-md-6 col-sm-6">
              <Center width={'100%'} height={'100%'}>
                <ParallaxAmenityImage />
              </Center>
            </div>
          </Fade>
          <div className="amenity-gap col-lg-1 col-sm-1 col-xs-1"></div>
          <div className="amenities-column col-lg-4 col-md-5 col-sm-5  col-xs-12">
            <Center width={'100%'}>
            <div style={{textAlign: 'center', fontFamily: 'proxima-nova', fontSize: '18px', padding: '1em 0em', paddingTop: 0}}>
              <Fade top>
                <h1 className="ourStandardH1" style={{textTransform: 'uppercase', textAlign: 'center'}}>Amenities</h1>
              </Fade>
            </div>
            {AmenitiesArray.map((x) => {
              var classSmall = 'col-sm-4';
              return (
                    <div className={"amenities-icon-container col-lg-4 col-md-4 col-xs-4 " + classSmall} style={{marginRight:'auto', padding: '20px 0px', textAlign: 'center', height: '75px'}}>
                      <Fade bottom>
                        <h4 className="amenities-icon">
                          {x.component}
                          <br/>
                          {x.text}
                        </h4>
                      </Fade>
                    </div>
                  )})}
            <div style={{clear: 'both'}}></div>
            <Fade bottom>
                <div style={{height: 'auto'}} className="flex-container furnishedLivingBtnContainer">
                    <Link style={{margin: 'auto', textDecoration: 'none'}} to={"/amenities"}>
                      <div className="furnishedLivingBtn" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', margin: 'auto', marginTop: '25px'}}>
                        <p>Explore Amenities</p>
                        <div className='fp-arrows-container' style={{width: '40px', overflow: 'hidden', display: 'flex'}}>
                            <div className="fp-left-arrow"><img style={{width: '17px'}} src={rightarrow} alt="See Floor Plans"/></div>
                            <div className="fp-right-arrow" style={{marginLeft: '35px'}}><img alt="See Floor Plans" style={{width: '17px'}} src={rightarrow}/></div>
                        </div>
                      </div>
                    </Link>
                </div>
            </Fade>
            </Center>
          </div>
          <div className="amenity-gap col-lg-1 col-sm-1"></div>
      </div>
    )
  }
}

export default Amenities;

const style = {
  frame: {
    width: '100%',
    backgroundSize: 'cover',
    willChange: 'scroll-position',
    backgroundPositionX: '50%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'transparent'
  }
}
const aFunc = (x, y) => {
  return {text: x, component: y}
}
const AmenitiesArray = [
  aFunc('King & Queen Beds', <FaBed className="snowFont" /> ),
  aFunc('Central A/C', <TiWeatherSnow className="snowFont" />),
  aFunc('Washer & Dryer', <MdLocalLaundryService className="snowFont"/>),
  aFunc('All Utilities', <MdAllInclusive className="snowFont" />),
  aFunc('HDTV, AppleTV, Netflix', <FaTelevision className="snowFont" />),
  aFunc('Housekeeping', <TiBell className="snowFont" />),
  aFunc('Property Parking', <MdLocalParking className="snowFont" />),
  aFunc('Wi-fi, phone, fax, printer', <MdWifi className="snowFont" />),
  aFunc('Full Kitchen', <MdKitchen className="snowFont" />)
]
const ParallaxAmenityImage = () => {
  return (
      <ParallaxBanner style={{height: '100%'}} layers={[{image: Five, amount: 0.2, slowerScrollRate: true}]}></ParallaxBanner>
  )
}



// WEBPACK FOOTER //
// ./src/Amenities.js